import { Box, Divider, HStack, Stack, Switch, Table, TableContainer, Tag, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import CompanyHeader from 'components/ui/CompanyHeader';
import { useListsByCompanies } from 'features/lists/hooks/useListsByCompanies';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export default function ListsCompanyView() {
  const companies = useListsByCompanies();
  const { setValue, watch } = useFormContext();
  const lists = watch('lists');

  const isCheckSelectAll = useCallback((company) => {
    const ids = company.lists.map(item => item.id);
    return ids.every(id => lists.includes(id)) 
  }, [lists]);

  const handleSelectAll = useCallback((company, isChecked) => {
    const ids = company.lists.map(item => item.id);
    const newValue = isChecked ? [...lists, ...ids] : lists.filter(id => !ids.includes(id));
    setValue('lists', newValue, { shouldValidate: true });
  }, [lists]);

  const handleSelectOne = useCallback((list, isChecked) => {
    const newValue = isChecked ? [...lists, list.id] : lists.filter(id => id !== list.id);
    setValue('lists', newValue, { shouldValidate: true });
  }, [lists]);

  if (!companies)
    return null;
  
  return (
    <Stack spacing="0px">
  { companies.map(company => (
      <Box key={`company-${company.id}`}>
        <HStack justifyContent="space-between">
          <CompanyHeader 
            company={company} 
            description={`${company.lists.length} listas`} 
          />
          <Switch 
            fontWeight="semibold"
            isChecked={isCheckSelectAll(company)}
            onChange={(e) => handleSelectAll(company, e.target.checked)}
          >
            Selecionar todas
          </Switch>
        </HStack> 
        <TableContainer mt="23px">
          <Table>
            <Thead>
              <Tr>
                <Th>Nome da lista</Th>
                <Th>Tags</Th>
                <Th width="100px"></Th>
              </Tr>
            </Thead>
            <Tbody>

            { company.lists.map(list => (
              <Tr key={`row-${list.id}`}>
                <Td>
                  {list.name}
                </Td>
                <Td>
                  <HStack spacing="8px" flexWrap="wrap">
                  {list.tags.map(tag => (
                    <Tag 
                      key={`tag-${tag.id}`} 
                      colorScheme={tag.colorScheme}
                    >
                      {tag.name}
                    </Tag>
                  ))}
                  </HStack>
                </Td>
                <Td textAlign="right">
                  <Switch 
                    isChecked={lists.includes(list.id)}
                    onChange={(e) => handleSelectOne(list, e.target.checked)}
                  >
                    Selecionar
                  </Switch>
                </Td>
              </Tr>
            ))}{}
            </Tbody>
          </Table>
        </TableContainer>
        <Divider my="50px" w="calc(100% + 40px)" left="-20px" pos="relative" />
      </Box>
  ))}
    </Stack>
  )
}
